import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ADMIN_TOKEN_KEY = "smarthub_admin_token";

const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Admin token expired or invalid — clear and redirect to login
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      if (window.location.pathname.startsWith("/admin") || window.location.pathname.startsWith("/control")) {
        if (window.location.pathname !== "/control") {
          window.location.href = "/control";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;
